import { $global_message_timeout } from "./_global_variables.js";

function addCloseListener($notification) {
  const $delete = $notification.querySelector(".delete");
  if ($delete) {
    $delete.addEventListener("click", () => {
      removeMessage($notification);
    });
  }
  if ($notification.classList.contains("is-success")) {
    setTimeout(function () {
      // check opacity: message might be deleted by user within timeout
      if (!$notification.style.opacity || $notification.style.opacity === 1) {
        removeMessage($notification);
      }
    }, $global_message_timeout * 1000);
  }
}

function removeMessage($notification) {
  const fadeOutEffect = setInterval(function () {
    if (!$notification.style.opacity) {
      $notification.style.opacity = 1;
    }
    if ($notification.style.opacity > 0) {
      $notification.style.opacity -= 0.1;
    } else {
      clearInterval(fadeOutEffect);
      $notification.parentNode.removeChild($notification);
    }
  }, 50);
}

function addMessage(message, type) {
  const messageWrapper = document.createElement("div");
  messageWrapper.classList.add(
    "notification",
    "has-text-centered",
    `is-${type}`,
  );
  messageWrapper.innerText = message;
  const deleteButton = document.createElement("button");
  deleteButton.classList.add("delete");
  messageWrapper.prepend(deleteButton);
  document.querySelector("#messages").appendChild(messageWrapper);
  addCloseListener(messageWrapper);
}

document.addEventListener("DOMContentLoaded", () => {
  (document.querySelectorAll(".notification") || []).forEach(
    ($notification) => {
      addCloseListener($notification);
      // Message API: remove message
      try {
        fetch("/api/messages/delete", {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: `{"messageId":"${$notification.getAttribute("id")}"}`,
        });
      } catch (error) {
        console.error(error.message);
      }
    },
  );
});

export { addMessage };
